import request from '@/utils/request'

/**
 * 获取分销关系列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listAffiliateRelation(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateRelation.listAffiliateRelation',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}